export default __webpack_public_path__ + "static/media/data.8b094d7a.png";